export function isValidUrl(url: string) {
  if (url) {
    let newUrl = null;
    try {
      newUrl = new URL(url);
    } catch (e) {
      /* */
    }
    return newUrl?.protocol === "https:";
  }
  return url;
}

export function isValidImageUrl(url: string) {
  if (url) {
    const localAssets = /^\/assets\/images\/.+$/i;
    return isValidUrl(url) || localAssets.test(url);
  }

  return false;
}

export function isValidColor(color: string) {
  if (color) {
    const hexColor = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i;
    const rgbColor = /^rgba?\(\s*(\d{1,3}\s*,\s*){2}\d{1,3}(\s*,\s*(0|1|0?\.\d+))?\s*\)$/;
    const cssVar = /^var\(--[a-zA-Z0-9-]+\)$/;

    return hexColor.test(color) || rgbColor.test(color) || cssVar.test(color);
  }

  return false;
}
